import { CreativeWorkTypeFilterItemFragment } from "@/gql/graphql"
import { useEffect } from "react"
import { create } from "zustand"

interface CreativeWorkTypesStore {
  creativeWorkTypes: (CreativeWorkTypeFilterItemFragment | null)[]
  setCreativeWorkTypes: (creativeWorkTypes: (CreativeWorkTypeFilterItemFragment | null)[]) => void
}

const useCreativeWorkTypesStore = create<CreativeWorkTypesStore>(set => ({
  creativeWorkTypes: [],
  setCreativeWorkTypes: creativeWorkTypes => set({ creativeWorkTypes }),
}))

export const useCreativeWorkTypesFilter = (orderBy: "name" | "popularity" = "name") => {
  const { creativeWorkTypes, setCreativeWorkTypes } = useCreativeWorkTypesStore()

  useEffect(() => {
    const fetchCreativeWorkTypes = async () => {
      const res = await fetch(`/api/filters/creative-work-types/${orderBy}`)
      if (res) {
        const data: { allCreativeWorkTypes: (CreativeWorkTypeFilterItemFragment | null)[] } = await res.json()
        setCreativeWorkTypes(data?.allCreativeWorkTypes)
      }
    }

    fetchCreativeWorkTypes()
  }, [orderBy])

  return creativeWorkTypes
}
